import { Container, Graphics, Rectangle, AnimatedSprite } from 'pixi.js';

import { config } from '../config/config';
import { events } from './events';
import { playObjectSfx, stopItemSfx, stopSfx } from '../helpers/sounds';
import { EVENT_OBJECT_CLICK, sendCustomEvent } from '../helpers/stats';
import { Area, Coordinates } from './declarations/PositionInfo';
import { ObjectConfig } from '../config/objectsConfig';

export default class ActiveObject extends Container {
  public id: string;
  private numFrames: number;
  private numSounds: number;
  private actualSoundIndex: number;
  private center: Coordinates;
  private animSprite: AnimatedSprite;
  private hitAreaDebugRect: Rectangle;

  constructor(id: string, position: Coordinates, hitArea: Area, objectInfo: ObjectConfig) {
    super();

    this.id = id;
    //console.log(`ActiveObject ${id}`, position, hitArea, objectInfo);

    this.numFrames = objectInfo.numFrames;
    this.numSounds = objectInfo.numSounds;
    this.actualSoundIndex = 0;

    this.x = Math.round(position.x);
    this.y = Math.round(position.y);
    this.eventMode = 'passive';
    this.zIndex = 3;
    this.hitArea = new Rectangle(hitArea.x - position.x, hitArea.y - position.y, hitArea.w, hitArea.h);
    this.hitAreaDebugRect = this.hitArea as Rectangle;

    this.center = {
      x: hitArea.x + hitArea.w / 2,
      y: hitArea.y + hitArea.h / 2,
    };

    const frames = [];
    for (let i = 0; i < this.numFrames; i++) {
      frames.push(`${this.id}_${i}.png`);
    }

    this.animSprite = AnimatedSprite.fromFrames(frames);
    this.addChild(this.animSprite);

    //this.on('pointerup', this.onPointerUp);

    if (config.DEBUG) {
      this._drawHitArea();
    }
  }

  setActive() {
    this.eventMode = 'static';
    this.cursor = 'pointer';
  }

  public onPointerUp() {
    sendCustomEvent(EVENT_OBJECT_CLICK, this.id);
    stopSfx();
    stopItemSfx();
    //console.log('=== POINTER UP ' + this.id + ' ' + this.animSprite.currentFrame + ' / ' + (this.numFrames - 1));

    if (this.animSprite.currentFrame === this.numFrames - 2) {
      this.emit(events.OBJECT_COLLECTED, this);
      this.eventMode = 'passive';
      //playSfx('object-collected');
      playObjectSfx(this.id, this.actualSoundIndex);
    } else {
      playObjectSfx(this.id, this.actualSoundIndex);
      this.actualSoundIndex = (this.actualSoundIndex + 1) % this.numSounds;
    }
    this.animSprite.gotoAndStop(this.animSprite.currentFrame + 1);
    setTimeout(() => {
      this.visible = false;
    }, 1000);
  }

  _drawHitArea() {
    const debugGr = new Graphics();

    debugGr.beginFill('0xFFFF00', 0.4);
    debugGr.drawRect(
      this.hitAreaDebugRect.x,
      this.hitAreaDebugRect.y,
      this.hitAreaDebugRect.width,
      this.hitAreaDebugRect.height,
    );
    debugGr.endFill();

    //top left
    debugGr.beginFill('0xFFFF00', 0.4);
    debugGr.drawCircle(this.hitAreaDebugRect.x, this.hitAreaDebugRect.y, 5);
    debugGr.endFill();

    //center
    debugGr.beginFill('0x0000FF', 0.4);
    debugGr.drawCircle(this.center.x - this.x, this.center.y - this.y, 5);
    debugGr.endFill();

    this.addChild(debugGr);
  }
}
